import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-male-chair-tai-chi-al',
	options: {
		userFlags: ['hasAccessToYogaVideos'],
		userTags: ['tai_chi_chair_yoga'],
	},
	landing: {
		ids: ['loader-chair-tai-chi-m', 'age-chair-tai-chi-m'],
		route: {
			path: '/chair-tai-chi-m-al',
			name: 'male-chair-tai-chi-funnel-al',
		},
	},
	funnel: {
		id: 'ob-male-tai-chi-chair-workouts-al',
		route: {
			path: '/chair-tai-chi-m-al/ob/:page(.*)?',
			name: 'activity-male-chair-tai-chi-al',
		},
		slug: 'activity-male-chair-tai-chi-al',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-chair-tai-chi-m-al',
	},
	upsell: {
		routeNames: ['upsell-activity-m'],
	},
}

export default appAreaConfig
